import { EnumValues } from '@/services/types/EnumValues';
import { TransactionSignEnum } from '@/services/types/TransactionData';

export const isCredit = (transactionSign: EnumValues<typeof TransactionSignEnum>) =>
  transactionSign === TransactionSignEnum.Credit;
